/**
 * 系统模块接口
 * @description 短信、文件上传、APK管理、日志等系统相关接口
 */

import axios from "@/utils/request";
import Api from "../api";
import * as Enum from "../enum";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/**
 * 发送短信
 */
export const Http_postSendSms = async (params: Request.SendSmsParams) => {
  /** 清理特定字段的空格和换行，并合并连续逗号 */
  const cleanedData = { ...params };
  const fieldsToProcessCommas: (keyof Pick<
    Request.SendSmsParams,
    "receiverName" | "mobile" | "email" | "orderNo"
  >)[] = ["receiverName", "mobile", "email", "orderNo"];
  for (const key of fieldsToProcessCommas) {
    if (typeof cleanedData[key] === "string") {
      const currentValue = cleanedData[key];
      const items = currentValue
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== "");

      if (items.length > 0) {
        cleanedData[key] = items.join("','");
      } else {
        cleanedData[key] = "";
      }
    }
  }
  return await axios.post(Api.POST_SEND_SMS, cleanedData);
};

/**
 * 短信详情
 */
export const Http_getMessageDetail = async (id: string) => {
  return await axios.get<ResponseData.MessageDetailData>(
    Api.GET_MESSAGE_DETAIL,
    {
      params: {
        id,
      },
    }
  );
};

/**
 * 重发信息
 */
export const Http_postMessageResend = async ({
  id,
  type,
}: {
  /** ID */
  id: string;
  /** 发送类型 0-短信, 1-邮件 */
  type: Enum.MessageType;
}) => {
  return await axios.post<boolean>(Api.POST_MESSAGE_RESEND, {
    messageRecordId: id,
    messageType: type,
  });
};

/**
 * 上报打印日志
 */
export const Http_postLogForFront = async (params: {
  type: number;
  data: string;
}) => {
  return await axios.post<any>(Api.POST_LOGFORFRONT, params);
};
